<template>
   <div style="background-color: #e6f0f5">
      <div
         id="customer-support"
         :class="breakpoint">
         <div class="container">
            <div class="d-flex justify-content-center">
               <div class="avatar">
                  <img
                     src="/wp-content/themes/findforsikring_2015-sommer/icons/rasmus-ikoner/Rasmus_Round-min.png"
                     alt="" />
               </div>
               <div class="d-flex align-items-center flex-column content">
                  <h1 class="font-weight-bold">Har du brug for hjælp?</h1>
                  <div class="help-text font-non-codensed">
                     <p>
                        Mange synes at forsikring er besværligt og forvirrende, og de ønsker sådan set bare at det skal
                        fungere med den rigtige dækning, til den rigtige pris, og så skal det naturligvis være nemt at
                        anmelde en skade.
                     </p>

                     Vi er klar til at hjælpe dig på telefonen med at indhente dine forsikringstilbud.
                  </div>
                  <button
                     class="btn btn-lg btn-secondary"
                     data-bs-toggle="modal"
                     data-bs-target="#call-me-modal"
                     style="font-size: 120%">
                     Tryk her for kundeservice
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
   name: 'MaterialCustomerSupportOld',
   computed: {
      ...mapGetters(['breakpoint']),
   },
};
</script>

<style lang="scss" scoped>
#customer-support {
   padding: 3em;
   margin-top: 4em;
   position: relative;
   background-color: var(--ff-stripe-bg);
   font-size: 17px;
   line-height: 1.5;
   color: var(--ff-dark-blue);

   &.sm {
      font-size: 15px;
   }

   &.xs {
      font-size: 13px;
   }

   .content {
      margin-top: 2em;

      .help-text {
         margin: 2em 0;
         text-align: center;
         //font-family: 'Lato', sans-serif;
         //font-weight: bold;
         line-height: 1.5 !important;
         font-size: 110%;
      }
   }

   .avatar {
      position: absolute;
      top: -60px;
      left: calc(50% - 55px);
      border-radius: 50%;
      border: 2px solid var(--ff-dark-blue);

      img {
         width: 110px;
         height: 110px;
      }
   }
}
</style>
